import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import TextButton from 'LuxKit/Button/TextButton'
import LineTrashAltIcon from 'LuxKit/Icons/line/LineTrashAltIcon'
import zIndex from 'styles/tools/z-index'
import LinePlusIcon from 'LuxKit/Icons/line/LinePlusIcon'
import { tileDesktopLayout } from './constants'

const StyledButtonsContainer = styled.div`
  z-index: ${zIndex.reviewCartButtons};
  display: flex;
  justify-content: start;
  column-gap: ${rem(8)};

  ${tileDesktopLayout} {
    justify-content: end;
  }
`

interface Props {
  isBookable?: boolean
  saveForLater?: boolean
  onSaveForLater?: React.MouseEventHandler<HTMLButtonElement>
  onDelete?: React.MouseEventHandler<HTMLButtonElement>
}

function CartReviewTileActions({
  isBookable,
  saveForLater,
  onSaveForLater,
  onDelete,
}: Props) {
  return <StyledButtonsContainer>
    {isBookable && <>
      {!saveForLater && <TextButton
        kind="secondary"
        size="small"
        shape="round"
        onClick={onSaveForLater}
      >
        Save for later
      </TextButton>}
      {saveForLater && <TextButton
        kind="primary"
        size="small"
        shape="round"
        startIcon={<LinePlusIcon />}
        onClick={onSaveForLater}
      >
        Add
      </TextButton>}
    </>}
    <TextButton
      kind="secondary"
      size="small"
      shape="round"
      startIcon={<LineTrashAltIcon />}
      onClick={onDelete}
    >
      Delete
    </TextButton>
  </StyledButtonsContainer>
}

export default CartReviewTileActions
